<template lang="pug">
div
  header.header
    h1.title Notificações
    el-button.delete-button(
      round
      size="medium"
      icon="el-icon-delete"
      type="text"
      @click="handleDelete"
    )
  GlobalWrapper
    nuxt
  TheBottomTabBar
</template>

<script>
import { mapActions } from 'vuex'
import TheBottomTabBar from '~/components/TheBottomTabBar'
import GlobalWrapper from '../components/GlobalWrapper'

export default {
  middleware: ['Authenticated'],
  components: {
    TheBottomTabBar,
    GlobalWrapper,
  },
  methods: {
    ...mapActions('notification', ['removeAllNotifications']),
    confirmDelete() {
      return this.$confirm(
        'Você tem certeza que deseja excluir todas as notificações?',
        'Atenção',
        {
          confirmButtonText: 'Sim, excluir notificações',
          cancelButtonText: 'Cancelar',
          type: 'warning',
          center: true,
          roundButton: true,
        }
      )
        .then(() => true)
        .catch(() => false)
    },
    async handleDelete() {
      const confirm = await this.confirmDelete()
      if (!confirm) return
      try {
        await this.removeAllNotifications()
      } catch (error) {
        console.error(error)
        this.$notify({
          title: 'Erro',
          message: 'Erro ao apagar notificação',
          type: 'error',
        })
      }
    },
  },
}
</script>

<style lang="sass">
body
  --bgColor: #EBEBEB
  --iconColor: #FFFFFF
  --iconActiveColor: #30BAE3
  --primaryColor: #232378
  --textColor: #767676
  --textHighlightColor: #232323
  --backgroundSteak: #ffaaa5
  --greenColor: #00e686
  --darkBlueColor: #1A4982
</style>

<style lang="sass" scoped>
.header
  background-color: #FFFFFF
  display: flex
  align-items: center
  justify-content: space-between
  padding: 15px
  border-bottom: 1px solid var(--bgColor)
.title
  color: var(--primaryColor)
  font:
    size: 1.6em
    weight: 600
  transition: filter .7s
.delete-button
  color: var(--primaryColor)
</style>
